// -------------------------------------------------------------------------
// Add a new row in an SQL table
// -------------------------------------------------------------------------

import React from 'react';

const AddRowForm = ({
    schema,
    primaryKey,
    values,
    dropdownOptions,
    onChange,
    onSave,
}) => {

return (
    <div className="adtab-add-form__fields">

        {schema
            .filter(col => col.column_name !== primaryKey)
            .map(col => {

                const options = dropdownOptions?.[col.column_name];

                return (
                    <label 
                        key={col.column_name}
                        className="adtab-add-form__field"
                    >

                        <span className="adtab-add-form__field-label">
                            {col.column_name}
                        </span>


                        {options ? (

                            // -----------------------------------------
                            // DROPDOWN
                            // -----------------------------------------

                            <select
                                className="adtab-input"
                                value={values[col.column_name] ?? ""}
                                onChange={e =>
                                    onChange(
                                        col.column_name,
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">
                                    -- Select --
                                </option>

                                {options.map(option => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                        ) : col.inputType === "checkbox" ? (

                            // -----------------------------------------
                            // BOOLEAN / CHECKBOX
                            // -----------------------------------------

                            <input
                                type="checkbox"
                                checked={values[col.column_name] ?? false}
                                onChange={e =>
                                    onChange(
                                        col.column_name,
                                        e.target.checked
                                    )
                                }
                            />

                        ) : (

                            // -----------------------------------------
                            // NORMAL INPUT
                            // -----------------------------------------

                            <input
                                className="adtab-input"
                                placeholder={col.column_name}
                                value={values[col.column_name] ?? ''}
                                onChange={e =>
                                    onChange(
                                        col.column_name,
                                        e.target.value
                                    )
                                }
                            />
                        )}
                    </label>
                );
            })
        }

        <button 
            className="adtab-btn adtab-btn--primary"
            onClick={onSave}
        >
            Save new row
        </button>

    </div>
);

};

export default AddRowForm;